/**
 * Copyright © 2022 Anagog Ltd. All rights reserved.
 */

export enum AnagogEventType {
	onCampaignTriggered = "onCampaignTriggered",
	onNotificationClick = "onNotificationClick",
	onSnapshotReport = "onSnapshotReport",
	onEncodedEnrichmentReport = "onEncodedEnrichmentReport",
    onStreamConnected = "onStreamConnected",
    onJedAIStatusChange = "onJedAIStatusChange",
	onBestMomentEvent = "onBestMomentEvent"
}